export default "__VITE_ASSET__L4hAW6Fr__"